module.exports = __webpack_public_path__ + "static/media/edit-icon.3ea03eb5.svg";